/**
 * The one catalogue-status chip — used on the board card and the pane row so the same status
 * reads the same everywhere (WSRADM-0049). CURRENT renders nothing.
 */
import type { SxProps, Theme } from '@mui/material';
import { Chip } from '@mui/material';
import { useCopy } from '@/hooks/useCopy';
import type { EffectiveStatus } from './catalogueStatus';

export function CatalogueStatusChip({
  status,
  sx,
}: {
  status: EffectiveStatus;
  sx?: SxProps<Theme>;
}) {
  const { t } = useCopy();
  switch (status) {
    case 'RETIRED':
      return <Chip size="small" label={t('config.board.status.retired', 'Retired')} sx={sx} />;
    case 'NOT_IN_CATALOGUE':
      return (
        <Chip
          size="small"
          label={t('config.board.status.notInCatalogue', 'Not in WStudio catalogue')}
          sx={sx}
        />
      );
    case 'LEGACY':
      return <Chip size="small" label={t('config.board.status.legacy', 'Legacy')} sx={sx} />;
    case 'CURRENT':
      return null;
  }
}
